import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription, interval } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import * as uuid from 'uuid';
import { isNullOrUndefined } from '../shared/utils';
import { isCanvasRendererHost } from 'src/app/canvas-renderer/canvas-renderer-host';

const TAB_MASTERY_UUID_NAMESPACE = "ba9b2da6-fb1b-4b61-a266-b89522cfdb34"
const TAB_MASTERY_EXPIRY_KEY = "tab_mastery_expirery_date";
const TAB_MASTERY_ID_KEY = "tab_master_id";
const TAB_MASTERY_EXPIRY_TIME = 500; // 0.5s;

@Injectable({
  providedIn: 'root'
})
export class TabMasteryService implements OnDestroy{

  public isMaster: boolean = false;
  public isMasterObservable = new BehaviorSubject<boolean>(false);

  private sessionId: string;

  private masteryCheckMasteryIntervalSub: Subscription;
  private masteryRefreshLeaseIntervalSub: Subscription;


  constructor() {
  	if (isCanvasRendererHost)
  		return;
    this.sessionId = uuid.v5("sesionId:"+Date.now(), TAB_MASTERY_UUID_NAMESPACE);

    this.masteryCheckMasteryIntervalSub = interval(TAB_MASTERY_EXPIRY_TIME).pipe(
        tap(() => this.checkMastery())
    ).subscribe();

    this.masteryRefreshLeaseIntervalSub = interval(TAB_MASTERY_EXPIRY_TIME / 2).pipe(
        filter(()=>localStorage.getItem(TAB_MASTERY_ID_KEY) == this.sessionId),
        tap(() => this.refreshLeaseOrAssumeMastery())
    ).subscribe();
  }

  private checkMastery(): void {
    if (localStorage.getItem(TAB_MASTERY_ID_KEY) == this.sessionId) {
      return;
    }

    if (document.hasFocus()) {
      this.refreshLeaseOrAssumeMastery();
      return
    }
    //if we were master but the key no longer matches we lost mastery
    if (this.isMaster)
      this.lostMastery();
      
    const masterExpieryTime = localStorage.getItem(TAB_MASTERY_EXPIRY_KEY);

    if (isNullOrUndefined(masterExpieryTime) || Number.parseInt(masterExpieryTime) < Date.now()) {
      // Old Master Has Expired
      this.refreshLeaseOrAssumeMastery();
    }
  }

  private refreshLeaseOrAssumeMastery(): void {
    localStorage.setItem(TAB_MASTERY_EXPIRY_KEY, (Date.now() + TAB_MASTERY_EXPIRY_TIME).toString());
    localStorage.setItem(TAB_MASTERY_ID_KEY, this.sessionId);

    if (!this.isMaster) {
      this.isMaster = true;
      this.isMasterObservable.next(true);
    }
  }

  private lostMastery(): void {
    this.isMasterObservable.next(false);

    this.isMaster = false;
  }

  private giveUpMastery(): void {
    this.isMaster = false;
    localStorage.removeItem(TAB_MASTERY_EXPIRY_KEY);
    localStorage.removeItem(TAB_MASTERY_ID_KEY);

    this.isMasterObservable.next(false);
  }

  ngOnDestroy(): void {
    this.giveUpMastery();
  }
}
